// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__Zn4eV","label":"Category_label__PoG55","content":"Category_content__2sdk0","header":"Category_header__1pi09","location":"Category_location__1--zq"};